import { render } from "./createCharge.vue?vue&type=template&id=c3b7b6d4&scoped=true"
import script from "./createCharge.vue?vue&type=script&lang=js"
export * from "./createCharge.vue?vue&type=script&lang=js"

import "./createCharge.vue?vue&type=style&index=0&id=c3b7b6d4&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b7b6d4"]])

export default __exports__